module.exports = __webpack_public_path__ + "static/media/kgif2.a555a2b7.gif";